import React, {Component} from 'react'
import { submit, isSubmitting } from 'redux-form'
import { connect } from 'react-redux'
import {
  TextInput,
  fetchEnd,
  fetchStart,
  showNotification,
  SimpleForm,
  SaveButton,
  ReferenceInput,
  SelectInput,
  required
} from 'react-admin'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Slide from '@material-ui/core/Slide'

import axiosClient from '../../../config/axios'
import { toggleGeneratePromoCodesModal } from '../../../redux/actions/modals'
import CancelButton from '../../../components/CancelButton'

const FORM_NAME = 'generate-promo-codes'

function Transition (props) {
  return <Slide direction='up' {...props} />
}

class EditPassword extends Component {
  constructor (props) {
    super(props)

    this._submit = this._submit.bind(this)
  }

  async _submit (values) {
    const { fetchStart, fetchEnd, showNotification } = this.props
    try {
      // Dispatch an action letting react-admin know a API call is ongoing
      fetchStart()

      await axiosClient()
        .post(`/promo-code/generate`,
          {
            numberOfCodes: values.numberOfCodes,
            appId: values.appId
          },
          { responseType: 'blob' },
        ).then(res => {
          const href = window.URL.createObjectURL(res.data)
          // create "a" HTML element with href to file & click
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', 'promocodes.csv'); //or any other extension
          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        })

      this.props.toggleGeneratePromoCodesModal()
      showNotification(`${values.numberOfCodes} codes were generated`, 'info')
      fetchEnd()
    } catch (err) {
      showNotification(err.message, 'error')
      fetchEnd()
    } finally {
      fetchEnd()
    }
  }

  render () {
    return (
      <Dialog
        fullScreen={window.innerWidth < 600}
        open={this.props.isOpen}
        onClose={this.props.toggleGeneratePromoCodesModal}
        TransitionComponent={window.innerWidth < 600 ? Transition : undefined}
      >
        <DialogTitle>Generate promo codes</DialogTitle>
        <DialogContent>
          <SimpleForm
            form={FORM_NAME}
            onSubmit={this._submit}
            toolbar={null}
            validate={validate}
          >
            <ReferenceInput
              label='App'
              source='appId'
              reference='app'
              allowEmpty
              validate={required()}
              perPage={100}
              filterToQuery={searchText => ({ name: {$regex: searchText} })}
              sort={{ field: 'name', order: 'ASC' }}
            >
              <SelectInput optionText='name' translateChoice={false} validate={required()} />
            </ReferenceInput>
            <TextInput
              source='numberOfCodes'
              type='number'
              inputProps={{
                min: 1,
                max: 10000
              }}
              defaultValue={100}
              validate={required()}
              resettable
            />
          </SimpleForm>
        </DialogContent>
        <DialogActions>
          <CancelButton
            onClick={this.props.toggleGeneratePromoCodesModal}
          />
          <SaveButton
            saving={this.props.isSubmitting}
            onClick={() => this.props.submit(FORM_NAME)}
          />
        </DialogActions>
      </Dialog>
    )
  }
}

const validate = (values) => {
  const errors = {}
  if (values.numberOfCodes) {
    if (values.numberOfCodes > 10000) {
      errors.numberOfCodes = 'The maximum number of codes is 10000'
    } else if (values.numberOfCodes < 1) {
      errors.numberOfCodes = 'The minimum number of codes is 1'
    }
  }

  return errors
}

const mapStateToProps = (state) => ({
  ...state.modals.generatePromoCodes,
  isSubmitting: isSubmitting(FORM_NAME)(state)
})

export default connect(mapStateToProps, {
  toggleGeneratePromoCodesModal,
  fetchEnd,
  fetchStart,
  showNotification,
  submit
})(EditPassword)
